export const VARIABLES = {
  // for dev
  // url: "http://64.226.76.196:8020",
  // career_login : "car-vqev"

  // for testing
  // url: "http://127.0.0.1:8011",
 url: "https://rms-api-clone.fluidscapes.in/",
  career_login: "car-mude",
  career_redirection: "https://candidate-clone.fluidscapes.in/",
  logout_url: "https://candidate-clone.fluidscapes.in/",
  fsc_redirection: "https://fluidscapes.in/"
};
